/**
  * Проверить роль
  * @param {
 *   userRoles: String[]
 *   roles: String[] | String
 *  } params
 * @return boolean
*/
const checkRole = (userRoles = [], roles) => {
  if (Array.isArray(roles)) {
    return userRoles.some((role) => roles.includes(role));
  }

  if (typeof roles === 'string') {
    return userRoles.includes(roles);
  }

  return false;
};

export default checkRole;
